// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  encryptSecretKey: 't2-secret',
  // Socket_BASE: "http://ec2-13-232-72-189.ap-south-1.compute.amazonaws.com:8000/",
  // http://6ced-2409-4064-a91-8b4f-2a-ff83-556f-97e0.ngrok.io
  Socket_BASE: "https://devapi.terminal2online.com/",
  customer_portal_url:"https://dev.terminal2online.com/",
  API_BASE: "https://devapi.terminal2online.com/api/",
  V2_API_BASE: "https://devapi.terminal2online.com/api/V2/",
  V3_API_BASE: "https://devapi.terminal2online.com/api/V3/",
  razorPayKey: 'rzp_test_wbFQFynujoIyWv',
  razorPaySecretKey: 'ZbfRxWPQYR775UyY6RRuDdKv',
  title:'Dev'
};

// export const environment = {
//   production: false,
//   encryptSecretKey: 't2-secret',
//   // API_BASE: "http://t2-fe-hosting.s3-website-us-east-1.amazonaws.com/",
//   Socket_BASE: "https://beta-api.terminal2online.com/",
//   API_BASE: "https://beta-api.terminal2online.com/api/",
//   customer_portal_url:"https://beta.terminal2online.com/",
//   V2_API_BASE: "https://beta-api.terminal2online.com/api/V2/",
//   V3_API_BASE: "https://beta-api.terminal2online.com/api/V3/",
//   razorPayKey: 'rzp_test_wbFQFynujoIyWv',
//   razorPaySecretKey: 'ZbfRxWPQYR775UyY6RRuDdKv',
//   title:'Beta'
// };


// export const environment = {
//   production: true,
//   encryptSecretKey: 't2-secret',
//   // API_BASE: "http://t2-fe-hosting.s3-website-us-east-1.amazonaws.com/",
//   Socket_BASE: "https://beta-api.terminal2online.com/",
//   API_BASE: "https://beta-api.terminal2online.com/api/",
//   customer_portal_url:"https://beta.terminal2online.com/",
//   V2_API_BASE: "https://beta-api.terminal2online.com/api/V2/",
//   V3_API_BASE: "https://beta-api.terminal2online.com/api/V3/",
//   razorPayKey: 'rzp_test_wbFQFynujoIyWv',
//   razorPaySecretKey: 'ZbfRxWPQYR775UyY6RRuDdKv',
//   title:'Beta'
// };


// export const environment = {
//   production: false,
//   encryptSecretKey: 't2-secret',
//   // API_BASE: "http://ec2-35-154-176-198.ap-south-1.compute.amazonaws.com:8000/api/",
//   Socket_BASE: "https://demoapi.terminal2online.com/",
//   API_BASE: "https://demoapi.terminal2online.com/api/",
//   customer_portal_url:"https://demo.terminal2online.com/",
//   V2_API_BASE: "https://demoapi.terminal2online.com/api/V2/",
//   V3_API_BASE: "https://demoapi.terminal2online.com/api/V3/",
//   razorPayKey: 'rzp_test_wbFQFynujoIyWv',
//   razorPaySecretKey: 'ZbfRxWPQYR775UyY6RRuDdKv',
//   title:'Demo'
// };


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
